
export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-6">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-black tracking-tight">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-amber-100 to-amber-200">GUEPARDO</span>
              <span className="text-white ml-2">AGENCIA</span>
            </h2>
            <p className="text-gray-400 mt-2">Velocidade e Precisão em Marketing Digital</p>
          </div>

          <div className="border-t border-gray-800 pt-8 space-y-4">
            <p className="text-gray-400 text-sm">
              © GUEPARDO AGENCIA | Assessoria de Marketing - TODOS OS DIREITOS RESERVADOS.
            </p>
            <p className="text-gray-500 text-sm">
              ESTE SITE FOI CRIADO EM 2011
            </p>
          </div>
        </div>
      </div>

      <a
        href="https://api.whatsapp.com/send?phone=5519982674838&text=Olá, gostaria de saber mais sobre os serviços da GUEPARDO AGENCIA"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 z-50 cursor-pointer animate-pulse"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </footer>
  );
}
